import React from 'react';

export default class PublicInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showPassword: false };
  }

  static defaultProps =
    {
      type: "text",
      name: "",
      placeholder: "",
      onChange: function () { },
      img: "",
      maxLength: null
    };

  handleKeyPress = e => {
    const { allowedRegex } = this.props;
    if (allowedRegex && !allowedRegex.test(e.key)) {
      e.preventDefault();
    }
  };

  handlePaste = e => {
    const { maxLength, value } = this.props;
    if (!maxLength) return;
    const paste = (e.clipboardData || window.clipboardData).getData('text');
    const available = maxLength - value.length;
    if (available <= 0) {
      e.preventDefault();
      return;
    }
    const toInsert = paste.slice(0, available);
    e.preventDefault();
    document.execCommand("insertText", false, toInsert);
  };

  handleChange = e => {
    const { maxLength, onChange } = this.props;
    let val = e.target.value;
    if (maxLength != null && val.length > maxLength) {
      val = val.slice(0, maxLength);
      e.target.value = val;
    }
    onChange(e);
  };

  toggleVisibility = () => {
    this.setState(prev => ({ showPassword: !prev.showPassword }));
  };

  render() {
    const { img, maxLength, allowedRegex, onChange, type, ...rest } =
      this.props;
    const { showPassword } = this.state;

    const inputType = type === 'password' && showPassword ? 'text' : type;

    return (
      <div className="form-group mb-3" style={{ position: 'relative' }}>
        {img && (
          <img
            src={img}
            alt=""
            style={{ position: 'absolute', left: 10, top: 10 }}
          />
        )}

        <input
          {...rest}
          type={inputType}
          maxLength={maxLength}
          onKeyPress={this.handleKeyPress}
          onPaste={this.handlePaste}
          onChange={this.handleChange}
          className="form-control"
          style={{
            border: 'none',
            borderBottom: 'solid 1.7px #dcdcdc',
            padding: '10px 40px 10px 40px',
          }}
        />

        {type === 'password' && (
          <button
            type="button"
            onClick={this.toggleVisibility}
            style={{
              position: 'absolute',
              right: 10,
              top: 10,
              background: 'transparent',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
            }}
          >
            <i
              className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
              aria-hidden="true"
            />
          </button>
        )}
      </div>
    );
  }
}